var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alert"}},[_c('div',{staticClass:"modal center-hor align-ver",on:{"click":_vm.closeAlert}},[_c('div',{staticClass:"modal-dialog bg-light padding-15 margin-10 radius-10"},[(!_vm.alertInfo)?_c('img',{attrs:{"src":require("@/assets/alert.png")}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.model))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93c08bca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert.vue
// module id = null
// module chunks = 